<template>
  <div class="app">
    <router-view />
    <div class="tabbar" v-if="showTabbar">
      <router-link to="/home" :class="{ active: $route.meta.tab === 'home' }">
        <span class="ic">🏠</span>首页
      </router-link>
      <router-link to="/my" :class="{ active: $route.meta.tab === 'my' }">
        <span class="ic">👤</span>我的
      </router-link>
    </div>
    <LoginPopup ref="loginPopup" @loginSuccess="onLoginSuccess" />
  </div>
</template>

<script>
import LoginPopup from "@/components/login/LoginPopup.vue";
import bus from "@/utils/eventBus.js";
import { bindLatestReferral } from "@/utils/referral.js";

export default {
  name: "App",
  components: { LoginPopup },
  data() {
    return {
      pendingLoginCallback: null,
    };
  },
  computed: {
    showTabbar() {
      return !!this.$route.meta.tab;
    },
  },
  created() {
    bindLatestReferral();
    bus.$on("show-login", (payload) => {
      this.pendingLoginCallback = (payload && payload.onSuccess) || null;
      this.$refs.loginPopup.Show();
    });
  },
  methods: {
    onLoginSuccess() {
      bindLatestReferral();
      if (this.pendingLoginCallback) {
        this.pendingLoginCallback();
        this.pendingLoginCallback = null;
      } else {
        // 没有明确的"登录完要干嘛"回调，说明是页面自己请求数据时被网关拒绝(未登录)、
        // 自动弹出的登录窗——这种情况原来失败的请求不会自动重试，页面会一直是空的，
        // 干脆整页刷新一次，让所有数据重新按已登录状态请求一遍，最省事也最不容易漏
        window.location.reload();
      }
    },
  },
};
</script>
